import OrderItemCleanupDialog, { CompletedOrderItem, OrderedItem, OrderedKitItem } from "../cleanup/OrderItemCleanupDialog";
import useFormApi from "../../api/FormApi";
import useOrderApi, { } from "../../api/OrderApi";

interface Props {
  customerId: number;
  open: boolean;
  onCleanupConfirmed: (messages: string[]) => void;
  onCleanupCanceled: () => void;
}

const FormsCleanupDialog = (props: Props) => {
  const formApi = useFormApi();
  const orderApi = useOrderApi();

  const fetchCompletedOrderItems = (customerId: number) : Promise<CompletedOrderItem[]> =>
    formApi
      .fetchCompletedOrderForms(customerId)
      .then(orderForms => orderForms
        .map(completedOrderForm => ({
          itemId: completedOrderForm.formId,
          name: completedOrderForm.name,
          latestCompletionDate: completedOrderForm.latestCompletionDate
        })));

  const fetchActiveOrderedItems = (customerId: number) : Promise<OrderedItem[]> =>
    orderApi
      .fetchActiveOrderedForms(customerId)
      .then(orderedForms => orderedForms
        .map(orderedForm => ({
          item: orderedForm.form
        })));

  const fetchActiveOrderedKitItems = (customerId: number) : Promise<OrderedKitItem[]> =>
    orderApi
      .fetchOrderedKitForms(customerId)
      .then(orderedKitForms => orderedKitForms
        .map(orderedKitForm => ({
          item: orderedKitForm.form,
          kit: orderedKitForm.kit,
          order: orderedKitForm.order
        })));

  return (
    <OrderItemCleanupDialog
      customerId={ props.customerId }
      open={ props.open }
      onCleanupConfirmed={ props.onCleanupConfirmed }
      onCleanupCanceled={ props.onCleanupCanceled }
      fetchItems={ customerId => formApi.fetchForms(customerId, 0) } // TODO: hardcoded 0 as priceListId
      fetchCompletedOrderItems={ fetchCompletedOrderItems }
      fetchActiveOrderedItems={ fetchActiveOrderedItems }
      fetchActiveOrderedKitItems={ fetchActiveOrderedKitItems }
      deleteItem={ (customerId, formId) => formApi.deleteForm(customerId, 0, formId) } // TODO: hardcoded 0 as priceListId
      messages={({
        itemDeletedSuccessfully: 'Usunięto formatkę',
        failedToDeleteItem: 'Napotkano PROBLEM podczas usuwania formatki',
        used: 'wykorzystywana'
      })}
    />);
}

export default FormsCleanupDialog;